class ScrollDownHint
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains '.scroll-down-hint--bound'
            @.clickable = @.$el.classList.contains 'scroll-down-hint--clickable'
            @.shown = !@.$el.classList.contains 'scroll-down-hint--hidden'
            
            @.$el.classList.add 'scroll-down-hint--bound'
            @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'scroll-down-hint-shown', (e) ->
            shown = e.detail?.shown ? false
            self.SetShown shown
            return
        if @.clickable
            @.$el.addEventListener 'click', (e) ->
                e.preventDefault()
                if self.shown
                    window.scrollTo {
                        behavior: 'smooth'
                        left: 0
                        top: window.scrollY + window.innerHeight
                    }
                return
        return
    
    SetShown: (state) ->
        @.shown = state
        if state
            @.$el.classList.remove 'scroll-down-hint--hidden'
        else
            @.$el.classList.add 'scroll-down-hint--hidden'
        return

BindScrollDownHints = ->
    document.querySelectorAll '.scroll-down-hint:not(.scroll-down-hint--bound)'
        .forEach (el) ->
            new ScrollDownHint el
            return
    return

window.addEventListener 'bind-components', BindScrollDownHints